/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint quote-props: 0 */
import * as Blockly from 'blockly';
import colors from './colors';

// La v13 dibuja el handle con `thickness - 5`: con 11 queda en los 6px de prod.
Blockly.Scrollbar.scrollbarThickness = 11;

// Padding de los botones del flyout ("Crear variable…") igual al de prod; la v13
// no lo aplica a los labels de categoría.
Blockly.FlyoutButton.TEXT_MARGIN_X = 40;
Blockly.FlyoutButton.TEXT_MARGIN_Y = 10;

// No se resuelve por CSS: la v13 aplica estos colores inline y con CSS propio, y
// le ganan a las reglas del shell. El modo se cambia con `workspace.setTheme()`.
const COMPONENTES = {
  dark: {
    'workspaceBackgroundColour': '#0d1824',
    'toolboxBackgroundColour': '#1e2e46',
    'toolboxForegroundColour': '#fff',
    'flyoutBackgroundColour': '#212c4c',
    'flyoutForegroundColour': '#fff',
  },
  light: {
    'workspaceBackgroundColour': '#fff',
    'toolboxBackgroundColour': '#f6f6f6',
    'toolboxForegroundColour': '#575e75',
    'flyoutBackgroundColour': '#ececec',
    'flyoutForegroundColour': '#575e75',
  },
};

const definirTema = (nombre, componentes) => Blockly.Theme.defineTheme(nombre, {
  'base': Blockly.Themes.Classic,
  'categoryStyles': {
    'procedure_category': {
      'colour': colors.COLOUR_PROCEDURES,
    },
    'variable_dynamic_category': {
      'colour': colors.COLOUR_VARIABLES,
    },
    'control_category': {
      'colour': colors.COLOUR_CONTROL,
    },
    'logic_category': {
      'colour': colors.COLOUR_LOGIC,
    },
    'math_category': {
      'colour': colors.COLOUR_MATH,
    },
    'text_category': {
      'colour': colors.COLOUR_TEXT,
    },
    'communication_category': {
      'colour': colors.COLOUR_COMMUNICATION,
    },
    'inputs_category': {
      'colour': colors.COLOUR_ENTRADAS,
    },
    'digital_inputs_category': {
      'colour': colors.COLOUR_ENTRADAS,
    },
    'analogue_inputs_category': {
      'colour': colors.COLOUR_ENTRADAS,
    },
    'outputs_category': {
      'colour': colors.COLOUR_SALIDAS,
    },
    'screens_category': {
      'colour': colors.COLOUR_LCD,
    },
    'camera_category': {
      'colour': colors.COLOUR_CAMERA,
    },
    'motors_category': {
      'colour': colors.COLOUR_SERVO,
    },
    'special_category': {
      'colour': colors.COLOUR_MORSE,
    },
  },
  'blockStyles': {
    'colour_blocks': {
      'colourPrimary': '#CF63CF',
      'colourSecondary': '#C94FC9',
      'colourTertiary': '#BD42BD',
    },
    'control_blocks': {
      'colourPrimary': colors.COLOUR_CONTROL,
    },
    'procedure_blocks': {
      'colourPrimary': colors.COLOUR_PROCEDURES,
    },
    'variable_dynamic_blocks': {
      'colourPrimary': colors.COLOUR_VARIABLES,
    },
    'logic_blocks': {
      'colourPrimary': colors.COLOUR_LOGIC,
    },
    'text_blocks': {
      'colourPrimary': colors.COLOUR_TEXT,
    },
    'camera_blocks': {
      'colourPrimary': colors.COLOUR_CAMERA,
    },
  },
  'componentStyles': {
    ...componentes,
    'flyoutOpacity': 1,
    // Color del scrollbar de prod; la v13 trae #ccc hardcodeado si no se define.
    'scrollbarColour': '#CECDCE',
    'scrollbarOpacity': 1,
    'blackBackground': '#333',
  },
});

// Los nombres tienen que ser distintos (`defineTheme` pisa por nombre) y no se
// pueden renombrar: bajan como clase `zelos-theme`/`zeloslight-theme` que usa
// toolboxCategory.scss.
Blockly.Themes.Educabot = definirTema('Zelos', COMPONENTES.dark);
Blockly.Themes.EducabotLight = definirTema('ZelosLight', COMPONENTES.light);

export const temaPara = (modoOscuro) => (
  modoOscuro === false ? Blockly.Themes.EducabotLight : Blockly.Themes.Educabot
);
